<an-base-modal tabindex="0" (onCloseModal)="closeModal()" [largeCloseIcon]="true">
  <div class="iframe-content">
    <iframe [id]="data.id" [title]="data.title" [frameBorder]="false" [src]="data.src | safeSrc"></iframe>
  </div>
</an-base-modal>